// extracted by mini-css-extract-plugin
export default {"bpk-scrim-content":"bpk-scrim-content_bpk-scrim-content__NDZmY"};